var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_vm._m(0),_c('div',{staticClass:"contentMain",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-text_1 flex-row justify-between"},[_c('div',{staticClass:"box_8 flex-col"}),_c('span',{staticClass:"text-group_1"},[_vm._v("公司介绍")]),_c('div',{staticClass:"group_2 flex-col"})])
}]

export { render, staticRenderFns }